export enum OperatorAccount {
  nonProfit = 'nonProfit',
  forProfit = 'forProfit',
}
